<script>
import Vue from "vue";
import store from "./store";
import AnnouncementsList from "./vue-components/announcements/announcements-list";
import NewsList from "./vue-components/news-list/news-list";
import ConfAgendaMain from "./vue-components/conference-agenda/ConfAgendaMain";
import CtaIconPanels from "./vue-components/cta-icon-panels/cta-icon-panels";

(function() {
    // don't run vue code under the following circumstances:
    if (
        document.querySelector("body.sfPageEditor") ||
        document.querySelector(".mg-searchblox-results")
    ) {
        return;
    }
    new Vue({
        el: "#site-content",
        store,
        components: {
            "mw-announcement-list": AnnouncementsList,
            "mw-news-list": NewsList,
            "conference-agenda": ConfAgendaMain,
            "mw-2026-cta-icon-panels": CtaIconPanels
        },
        data: {
            userAgrees: false
        },
        methods: {
        },
        created() {
        }
    })
})();
</script>


// WEBPACK FOOTER //
// src/js/app.vue